(() => {
// A short-lived display snapshot only. Never used for checkout, pricing or authentication.
const key = 'fp_store_cart_count_v1';
const domain = location.hostname === 'fivepointfabric.com' || location.hostname.endsWith('.fivepointfabric.com') ? '; Domain=fivepointfabric.com' : '';
function record(count) {
  if (!Number.isSafeInteger(count) || count < 0) throw new Error('Invalid cart quantity');
  document.cookie = key + '=' + count + ':' + Date.now() + '; Path=/; Max-Age=600; SameSite=Lax; Secure' + domain;
}
function unavailable() { document.cookie = key + '=; Path=/; Max-Age=0; SameSite=Lax; Secure' + domain; }
let request, generation = 0;
async function refresh() {
  const current = ++generation;
  request?.abort(); const controller = new AbortController(); request = controller;
  const timer = setTimeout(() => { controller.abort(); if (current === generation) unavailable(); }, 8000);
  try {
    const root = document.querySelector('[data-dss-market-context]')?.dataset.root;
    if (!root || !root.startsWith('/') || root.startsWith('//')) throw new Error('Store route unavailable');
    const response = await fetch(root.replace(/\/$/, '') + '/cart.js', {credentials:'same-origin', cache:'no-store', signal:controller.signal});
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json(); if (!controller.signal.aborted && current === generation) record(cart.item_count);
  } catch { if (!controller.signal.aborted && current === generation) unavailable(); }
  finally { clearTimeout(timer); }
}
import('@shopify/events').then(({StandardEvents}) => document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const current = ++generation;
  request?.abort();
  if (!event.promise) {unavailable();return;}
  event.promise.then(({cart,detail}) => { if (current !== generation) return; if (detail?.didError) throw new Error('Cart change failed'); record(cart.totalQuantity); }).catch(() => { if (current === generation) unavailable(); });
})).catch(unavailable);
window.addEventListener('focus', refresh);
window.FivePointStoreCounts = {ready: refresh()};
})();
